export default __webpack_public_path__ + "static/media/mawani_video.d6fa002e.mp4";